// extracted by mini-css-extract-plugin
export default {"container":"DaysField_container__Stx7N","suffix":"DaysField_suffix__pFtOR"};